const ROOT_DIR = '/';

const MAX_NAME_LENGTH = 24;

const IMAGE_TYPE = 'IMAGE_TYPE';
const OFFICE_TYPE = 'OFFICE_TYPE';
const PDF_TYPE = 'PDF_TYPE';
const TEXT_TYPE = 'TEXT_TYPE';
const VIDEO_TYPE = 'VIDEO_TYPE';
const SOUND_TYPE = 'SOUND_TYPE';
const OTHER_TYPE = 'OTHER_TYPE';

const IMAGE_ICON = {
    icon: 'mdi-image',
    color: '#FFD618'
};

const VIDEO_ICON = {
    icon: 'mdi-file-video',
    color: '#6FA2CE'
};

const SOUND_ICON = {
    icon: 'mdi-bookmark-music',
    color: '#B0D2C2'
};

const ZIP_ICON = {
    icon: 'mdi-folder-zip',
    color: '#AB9681'
};

const TEXT_ICON = {
    icon: 'mdi-file-document',
    color: '#3200E6'
};

const PDF_ICON = {
    icon: 'mdi-file-document',
    color: '#EB407C'
};

const FOLDER_ICON = {
    icon: 'mdi-folder',
    color: '#818180'
};

const SHEET_ICON = {
    icon: 'mdi-border-all',
    color: '#23AE84'
};

const POWERPOINT_ICON = {
    icon: 'mdi-chart-pie',
    color: '#F39314'
};

const GENERIC_ICON = {
    icon: 'mdi-file',
    color: '#818180'
};

const FILES_ICONS = {
    folder: FOLDER_ICON,

    pdf: PDF_ICON,

    doc: TEXT_ICON,
    docx: TEXT_ICON,
    odt: TEXT_ICON,

    xls: SHEET_ICON,
    xlsx: SHEET_ICON,
    xlsm: SHEET_ICON,
    xlsb: SHEET_ICON,
    ods: SHEET_ICON,
    csv: SHEET_ICON,

    ppt: POWERPOINT_ICON,
    pptx: POWERPOINT_ICON,
    pptm: POWERPOINT_ICON,
    potm: POWERPOINT_ICON,
    potx: POWERPOINT_ICON,
    ppsm: POWERPOINT_ICON,
    odp: POWERPOINT_ICON,

    mp4: VIDEO_ICON,
    wmv: VIDEO_ICON,
    mov: VIDEO_ICON,
    avi: VIDEO_ICON,
    flv: VIDEO_ICON,

    png: IMAGE_ICON,
    jpg: IMAGE_ICON,
    jpeg: IMAGE_ICON,
    tif: IMAGE_ICON,
    gif: IMAGE_ICON,
    psd: IMAGE_ICON,
    svg: IMAGE_ICON,

    wav: SOUND_ICON,
    mp3: SOUND_ICON,
    flac: SOUND_ICON,
    aac: SOUND_ICON,
    wma: SOUND_ICON,

    zip: ZIP_ICON,
    tar: ZIP_ICON,

    generic: GENERIC_ICON
};

const FILE_TYPES = {
    pdf: PDF_TYPE,

    doc: OFFICE_TYPE,
    docx: OFFICE_TYPE,
    odt: OFFICE_TYPE,

    xls: OFFICE_TYPE,
    xlsx: OFFICE_TYPE,
    xlsm: OFFICE_TYPE,
    xlsb: OFFICE_TYPE,
    ods: OFFICE_TYPE,
    csv: OFFICE_TYPE,

    ppt: OFFICE_TYPE,
    pptx: OFFICE_TYPE,
    pptm: OFFICE_TYPE,
    potm: OFFICE_TYPE,
    potx: OFFICE_TYPE,
    ppsm: OFFICE_TYPE,
    odp: OFFICE_TYPE,

    mp4: VIDEO_TYPE,
    wmv: VIDEO_TYPE,
    mov: VIDEO_TYPE,
    avi: VIDEO_TYPE,
    flv: VIDEO_TYPE,

    png: IMAGE_TYPE,
    jpg: IMAGE_TYPE,
    jpeg: IMAGE_TYPE,
    tif: IMAGE_TYPE,
    gif: IMAGE_TYPE,
    psd: IMAGE_TYPE,
    svg: IMAGE_TYPE,

    wav: SOUND_TYPE,
    mp3: SOUND_TYPE,
    flac: SOUND_TYPE,
    aac: SOUND_TYPE,
    wma: SOUND_TYPE,

    txt: TEXT_TYPE,

    generic: OTHER_TYPE
};
const getIcon = extension => FILES_ICONS[extension?.toLowerCase()] || FILES_ICONS.generic;
const getGenericType = extension => FILE_TYPES[extension?.toLowerCase()] || FILE_TYPES.generic;

export {
    MAX_NAME_LENGTH,
    ROOT_DIR,
    getIcon,
    getGenericType,
    IMAGE_TYPE,
    OFFICE_TYPE,
    PDF_TYPE,
    TEXT_TYPE,
    VIDEO_TYPE,
    SOUND_TYPE,
    OTHER_TYPE
};
